"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESG_BOTTLE_SIZE = exports.DailyHydration = exports.Type = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("../date");
const Unit = __importStar(require("../unit"));
exports.NAMESPACE = 'Culligan.Water';
exports.Type = effect_1.Schema.Enums({
    AmbientStill: 0,
    Chilled: 1,
    Sparkling: 2,
    LightlySparkling: 3,
    Hot: 4,
    ExtraHot: 5,
}).annotations({
    identifier: `${exports.NAMESPACE}.Type`,
});
exports.DailyHydration = effect_1.Schema.Record({
    key: date_1.TimelessUtcIsoDateString,
    value: effect_1.Schema.NonNegative,
}).annotations({
    identifier: `${exports.NAMESPACE}.DailyHydration`,
    description: 'A `Record` (readonly) associating `TimelessIsoDateString` to the amount of water (mL) consumed on that date',
    examples: [
        {
            ['2024-01-01T00:00:00.000Z']: 1_500,
            ['2024-01-02T00:00:00.000Z']: 1_000,
        },
    ],
});
/**
 * The size of a disposable plastic water bottle as per Culligan ESG standards.
 * For example, if a user dispenses one liter of water, this is considered 2 bottles saved.
 */
exports.ESG_BOTTLE_SIZE = Unit.Volume.Milliliter.make({ amount: 500 });
//# sourceMappingURL=water.js.map